export const DEBOUNCE_TIME = 500;

export const PAGE_CHECKOUT = {
  SHOPPING_CART: '1',
  PAYMENT: '2',
}

export const STEP_CHECKOUT = {
  ADDRESS_INFORMATION: 'address_information',
  PAYMENT_OPTIONS: 'payment_options',
  ORDER_DETAILS: 'order_details',
}

export const TYPE_NOTES = {
  OOS: 'oos',
  MAX_QUANTITY: 'max_quantity',
  LOCATION: 'location',
}
